import { render } from "./DamageComments.vue?vue&type=template&id=6cf91f20&scoped=true&ts=true"
import script from "./DamageComments.vue?vue&type=script&lang=ts"
export * from "./DamageComments.vue?vue&type=script&lang=ts"

import "./DamageComments.vue?vue&type=style&index=0&id=6cf91f20&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf91f20"]])

export default __exports__